import SportifyClient from './client';
let client = new SportifyClient();

//import NetBetAuth from 'netbet/auth';
//client.setAuth(NetBetAuth)

export default client